import type { Styles } from 'src/theme/themes';

export const styles = {
  // Chart background
  chartBackground: {
    height: '100%',
    width: '100%',
    position: 'relative',
    overflow: 'visible',
  },
  chartGrid: {
    height: '100%',
    width: '100%',
    position: 'absolute',
    paddingBottom: '3rem',
    bottom: 0,
  },
  chartGridRow: {
    display: 'flex',
    gap: 2,
    alignItems: 'start',
  },
  chartGridRowLabel: {
    width: '3.5rem',
    textAlign: 'end',
    whiteSpace: 'wrap',
  },
  chartData: {
    position: 'relative',
    height: '100%',
    marginLeft: '5rem',
    marginRight: '1rem',
    overflow: 'visible',
  },
} satisfies Styles;
